export default "__VITE_ASSET__k1OBqH6q__"